import { DialogflowIntegration } from './DialogflowIntegration'
import { connect } from 'react-redux'

const mapStateToProps = state => ({ activeBot: state.activeBot })

export default connect(mapStateToProps)(DialogflowIntegration)
